import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import './style.css';

import { Link } from 'react-router-dom';
import { ROUTE_NAMES } from '../../Routes';

// import GetInTouchSection from '../../Components/GetInTouchSection';
import StayConnected from '../../Components/StayConnectedSection';

import RightArrow from '../../assets/images/right-arrow.png';
import DownloadPDFSection from '../../Components/DownloadPDFSection';

export default function EBService() {
  const location = useLocation();

  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  return (
    <div className='eb-page'>
      <Helmet>
        <title>Starlife: EB-5 & Foreign Capital Consulting</title>
        <meta
          name='description'
          content='Explore the EB-5 program with Starlife Group for US residency through investment. Secure your future by investing in exclusive real estate projects and gain US residency.'
        />
        <meta
          name='keywords'
          content='EB-5 Visa, US Residency through Investment, Real estate investment for US residency, Starlife EB-5 program, US green card investment, Immigrant investor program'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='service-context'>
        <h2 className='service-page-title'>
          EB-5 & Foreign Capital Consulting
        </h2>
        <p className='service-page-text'>
          We guide international investors and EB-5 participants through U.S.
          real estate opportunities with security, clarity, and a focus on
          long-term success. Our experience navigating regulatory and
          immigration-linked investment structures makes us a valuable ally in
          cross-border ventures.
        </p>
      </div>
      <DownloadPDFSection />
      <div className='our-services-section'>
        <h2 className='section-title'>Other Services</h2>
        <div className='service-list'>
          <Link
            to={ROUTE_NAMES.CAPITALVENTURES}
            className='service-block green-block'
          >
            <h3>Capital Ventures</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
          <Link to={ROUTE_NAMES.LENDINGSOLUTIONS} className='service-block'>
            <h3>Lending Solutions</h3>
            <button className='right-arrow-btn'>
              <img src={RightArrow} alt='right-arrow' />
            </button>
          </Link>
        </div>
      </div>
      {/* <GetInTouchSection /> */}
      <StayConnected />
    </div>
  );
}
